import { useState, useCallback, useMemo } from 'react';
import {
  PROFILING_COTIZATION,
  PROFILING_COMPLETED, PROFILING_EMPTY_MATRIZ,
} from '../../../../../constants';

export const STATES = {
  PROFILING_COTIZATION,
  PROFILING_COMPLETED,
  PROFILING_EMPTY_MATRIZ,
  LOADER_PAGE: 'LOADER_PAGE',
};

const useStateMachine = (_currentState = STATES.LOADER_PAGE) => {
  const [currentState, setCurrentState] = useState(_currentState);

  const goToProfilingEmptyMatriz = useCallback(() => {
    setCurrentState(STATES.PROFILING_EMPTY_MATRIZ);
  }, []);
  const goToProfilingCotization = useCallback(() => {
    setCurrentState(STATES.PROFILING_COTIZATION);
  }, []);
  const goToProfilingCompleted = useCallback(() => {
    setCurrentState(STATES.PROFILING_COMPLETED);
  }, []);
  const goToLoaderPage = useCallback(() => {
    setCurrentState(STATES.LOADER_PAGE);
  }, []);

  const result = useMemo(
    () => (
      {
        STATES,
        currentState,
        goToProfilingCotization,
        goToLoaderPage,
        goToProfilingCompleted,
        goToProfilingEmptyMatriz,
      }
    ),
    [
      currentState,
      goToProfilingCotization,
      goToLoaderPage,
      goToProfilingCompleted,
      goToProfilingEmptyMatriz,
    ],
  );

  return result;
};

export default useStateMachine;
